import type { ReactElement } from 'react';
import { StarRating, useProductReviewSummaryQuery } from '@/entities/review';
import { STORE_DETAIL_REVIEWS_ID } from '@/shared/config';

interface ProductReviewSummaryLinkProps {
  readonly productId: string;
}

/** 후기가 있을 때만 가격 옆에 작게 보이고, 누르면 후기 영역으로 이동한다. */
export const ProductReviewSummaryLink = ({
  productId,
}: ProductReviewSummaryLinkProps): ReactElement | null => {
  const summary = useProductReviewSummaryQuery(productId);
  if (summary.data === undefined || summary.data.averageRating === null) return null;
  return (
    <a
      href={`#${STORE_DETAIL_REVIEWS_ID}`}
      className="inline-flex items-center gap-1 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <StarRating value={summary.data.averageRating} size="sm" />
      <span className="tabular-nums">{summary.data.averageRating.toFixed(1)}</span>
      <span className="text-muted-foreground tabular-nums">({summary.data.count})</span>
    </a>
  );
};
